
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RmRackDto } from './rm-racks.dto';

export class RmRackResponseModel extends GlobalResponseObject{
    data?: RmRackDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //RmRackDto
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RmRackDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 